export interface ICalculatedValueValidatable {
  name: string;
  shouldCalculate: boolean;
  isCalculatedValueEmpty: boolean;
}

export function instanceOfICalculatedValueValidatable(instance: any): instance is ICalculatedValueValidatable {
  if (!instance) { return false; }
  return (instance.shouldCalculate !== undefined) && (instance.isEmpty !== undefined);
}
